/**
 * Qué falta para que una campaña salga de verdad, en el aviso «Ojo: N de estos mensajes NO salieron de verdad» del
 * detalle (salieron en modo de prueba: WhatsApp simulado, o email sin una casilla conectada).
 *
 * El aviso decía siempre «Para enviar de verdad: conectá una línea de WhatsApp y una casilla de email»: también con
 * una línea ya conectada, y también a una persona de un cliente, que no tiene ni las líneas ni las casillas (son del
 * equipo: 403 SOLO_EQUIPO). QA del 08/10. Ahora:
 * - al equipo se le pide conectar la línea sólo si no hay ninguna conectada (y si no se pudo saber, no se afirma), y
 *   la casilla si hubo mails que no salieron;
 * - a un cliente se le dice que eso lo hace el equipo de Deenex.
 *
 * `simuladosWa`/`simuladosEmail`: los de cada canal (`results.porCanal`); `undefined` si el backend no los manda (se
 * toman los dos canales, como antes). Devuelve null si no hay nada que pedir.
 */
export function comoEnviarDeVerdad(o: {
  equipo: boolean;
  simuladosWa?: number;
  simuladosEmail?: number;
  /** las líneas de la marca: `null` si no se sabe (no se pudieron consultar, o un cliente, que no las ve) */
  hayLineaConectada: boolean | null;
}): string | null {
  const sinDetalle = o.simuladosWa === undefined && o.simuladosEmail === undefined;
  const porWa = sinDetalle || (o.simuladosWa ?? 0) > 0;
  const porEmail = sinDetalle || (o.simuladosEmail ?? 0) > 0;
  if (!o.equipo) {
    const partes = [porWa ? "la línea de WhatsApp" : "", porEmail ? "la casilla de email" : ""].filter(Boolean);
    return partes.length ? `Para que salgan de verdad hay que conectar ${partes.join(" y ")}: lo hace el equipo de Deenex.` : null;
  }
  const partes = [porWa && o.hayLineaConectada === false ? "una línea de WhatsApp" : "", porEmail ? "una casilla de email" : ""].filter(Boolean);
  return partes.length ? `Para enviar de verdad: conectá ${partes.join(" y ")}.` : null;
}
